import React, { Component } from 'react';
import { INPUT_TYPES } from '../../config/constants';
import TextInput from './text';
import Header from './header';
import RadioGroup from './radio';
import Select from './select';
import Address from './address';
import Toggle from './toggle';
import Number from './number';
import Date from './date';
import Time from './time';
import TermsAndConditions from './termsAndConditions';
import StarRating from './starRating';
import Label from './emptyLabel';
import FilePicker from './filePicker';
import Password from './password';
import Registration from './registration';
import Description from './description';
import Html from './html';
import SubmitButton from './submitButton';
import Button from './button';
import Image from './image';
import JavaScriptInput from './java-script';


export default class CustomInput extends Component {

    render() {
        const { initialValues, isResultInput } = this.props;
        const { type } = initialValues;
        return (
            <div className={ isResultInput ? 'input-container' : '' }>
            {
                (type === INPUT_TYPES.INPUT || type === INPUT_TYPES.TEXTAREA || type === INPUT_TYPES.EMAIL) ?
                    <TextInput
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.HEADER ?
                    <Header
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.STARS_RATING ?
                    <StarRating
                        multiple={false}
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.SELECT_RADIO ?
                    <RadioGroup
                        multiple={true}
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.SELECT || type === INPUT_TYPES.SELECT_USER_GROUP ?
                    <Select
                        multiple={true}
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                (type === INPUT_TYPES.SHORT_ADDRESS ||  type === INPUT_TYPES.LONG_ADDRESS) ?
                    <Address
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.TOGGLE ?
                    <Toggle
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.NUMBER ?
                    <Number
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.DATE ?
                    <Date
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.TIME ?
                    <Time
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.TERMS ?
                    <TermsAndConditions
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.LABEL ?
                    <Label
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.SECTION_BREAK ?
                <div className="result-input">
                    <div className="section-break" style={{ borderBottom: `1px solid ${this.props.color}` }}/>
                </div>
                :

                type === INPUT_TYPES.FILE_PICKER ?
                    <FilePicker
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.PASSWORD ?
                    <Password
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.REGISTRATION ?
                    <Registration
                        color={this.props.color}
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.DESCRIPTION ?
                    <Description
                        textColor={this.props.textColor}
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.HTML ?
                    <Html
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.SUBMIT_BUTTON ?
                    <SubmitButton
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                        formIsValid={this.props.formIsValid}
                        handleSubmit={this.props.handleSubmit || function () {}}
                        loadingSubmit={this.props.loadingSubmit || false}
                    />
                :

                (type === INPUT_TYPES.BUTTON || type === INPUT_TYPES.ADD_TO_CALENDAR )?
                   <Button
                       initialValues={initialValues}
                       isResultInput={isResultInput}
                   />
                :

                type === INPUT_TYPES.IMAGE ?
                    <Image
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                type === INPUT_TYPES.JAVA_SCRIPT ?
                    <JavaScriptInput
                        initialValues={initialValues}
                        isResultInput={isResultInput}
                    />
                :

                <div>{ type }</div>
            }
            </div>
        );
    }
}
